import isFinite from 'lodash/isFinite'
import toInteger from 'lodash/toInteger'

export function positiveIntFromQuery(raw: string | null): number | null {
  if (raw == null || raw === '') return null
  const n = toInteger(raw)
  return isFinite(n) && n > 0 ? n : null
}

export function positiveIntsFromQuery(raw: string | null): number[] {
  if (raw == null || raw === '') return []
  const ids = raw
    .split(',')
    .map((part) => positiveIntFromQuery(part.trim()))
    .filter((id): id is number => id != null)
  return [...new Set(ids)]
}

export function stepIdFromHash<T extends string>(hash: string, stepOrder: readonly T[]): T | null {
  const id = hash.startsWith('#') ? hash.slice(1) : hash
  return (stepOrder as readonly string[]).includes(id) ? (id as T) : null
}
